import { render, staticRenderFns } from "./NewReturnOrder.vue?vue&type=template&id=5bfdfa2e"
import script from "./NewReturnOrder.vue?vue&type=script&lang=js"
export * from "./NewReturnOrder.vue?vue&type=script&lang=js"
import style0 from "./NewReturnOrder.vue?vue&type=style&index=0&id=5bfdfa2e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports